import {getOneBy, createOne, updateOne, deleteOne, getOne} from "./Api";

const MODULE = 'annotation';

export function getOneByCode(code) {
	return getOneBy(MODULE, 'code', code);
}

export function getAnnotation(id) {
	return getOne(MODULE, id);
}

export function createAnnotation(data) {
	return createOne(MODULE, data);
}

export function updateAnnotation(data) {
	return updateOne(MODULE, data);
}

export function deleteAnnotation(id) {
	return deleteOne(MODULE, id);
}
